import { render, staticRenderFns } from "./Questiongroup.vue?vue&type=template&id=5cff1030&scoped=true"
import script from "./Questiongroup.vue?vue&type=script&lang=js"
export * from "./Questiongroup.vue?vue&type=script&lang=js"
import style0 from "./Questiongroup.vue?vue&type=style&index=0&id=5cff1030&prod&scoped=true&lang=css"
import style1 from "./Questiongroup.vue?vue&type=style&index=1&id=5cff1030&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cff1030",
  null
  
)

export default component.exports